export default{closeButton:"w_HO",icon:"w_HP"};
